"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    reportId: zod_1.z.string().uuid(),
});
exports.path = '/on-demand-irrigation-report-download';
//# sourceMappingURL=index.js.map